
import { defineComponent, computed, ref } from 'vue'
import { useRoute } from 'vue-router'
import StarXpGate from '@/components/star/StarXpGate.vue'
import StarTabBar from '@/components/star/StarTabBar.vue'
import { buildStarTextRoomUrl, buildStarPcLiveUrl } from '@/utils/starZoneHelper'

export default defineComponent({
  name: 'StarQuant',
  components: { StarXpGate, StarTabBar },
  setup() {
    const route = useRoute()
    const activeTab = ref('quant')

    const iframeUrl = computed(() => {
      const roomNo = (route.query.roomNo as string) || (route.query.r as string) || 'R11005844'
      const roomType = (route.query.roomType as string) || 'text'
      const routeQuery = route.query as Record<string, unknown>
      const hasPermission = !route.query.freeRoom

      if (roomType === 'live') {
        return buildStarPcLiveUrl(roomNo, routeQuery, hasPermission)
      }
      return buildStarTextRoomUrl(roomNo, routeQuery, hasPermission)
    })

    return { activeTab, iframeUrl }
  }
})
